import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';
import { kycRenewalText } from 'src/app/shared/kyc-renewal.texts';
import { getPendingPscSession, Profile } from 'src/app/shared/models/register.models';

@Component({
  selector: 'app-money-out-categorize',
  templateUrl: './money-out-categorize.component.html',
  styleUrls: ['./money-out-categorize.component.scss'],
})
export class MoneyOutCategorizeComponent implements OnInit {

  @Input() user: any;
  @Input() isMoneyIn: boolean = false;
  @Input() walletStatus: number;
  // Renovación del KYC: hay que verificar de nuevo aunque la última sesión esté VALIDATED
  @Input() kycRenewal: boolean = false;
  @Output() public continueEvent = new EventEmitter<any>();

  loading: boolean = true;
  step: number = 0;
  profile: Profile;
  reviewText: string;
  initBtnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  constructor(
    private profileService: ProfileService,
    private chdRef: ChangeDetectorRef,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.reviewText = this.translate.instant('MOVEMENTS.MANGOPAY_REVIEW');
    this.profileService.getProfile(this.user.username).subscribe(resp => {
      this.profile = resp;
      const idvStatus = resp.mangopayIdvSession?.status;
      const hasPendingPsc = !!getPendingPscSession(resp.mangopayIdvSession);
      if (idvStatus === 'VALIDATED' && !hasPendingPsc && !this.kycRenewal) {
        this.loading = false;
        this.onVerificationFinished();
        return;
      }
      // Con una PSC pendiente, el paso de verificación abre su enlace aunque la sesión esté VALIDATED o en REVIEW
      this.step = idvStatus === 'REVIEW' && !hasPendingPsc ? 2 : 1;
      this.loading = false;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  // Verificación terminada: si Mangopay aún no ha creado el wallet lo decimos, en vez de cerrar el modal sin más
  onVerificationFinished() {
    if (this.kycRenewal) {
      // Mangopay tarda unos minutos en confirmar la renovación: no se reintenta la operación, se avisa y se cierra
      this.reviewText = kycRenewalText(this.translate, 'KYC_RENEWAL.REVIEW');
      this.step = 2;
      this.chdRef.detectChanges();
    } else if (this.profile?.walletstatus === 0) {
      this.continue();
    } else {
      this.step = 2;
      this.chdRef.detectChanges();
    }
  }

  continue() {
    this.continueEvent.emit();
    this.chdRef.detectChanges();
  }
}
